import { get, post, getWithCancelToken, postWithCancelToken } from "./base";
import axios from "axios";

export default class Alignment {
  /**
   * 对齐列表
   * @param {*} data
   * @returns
   */
  static getTasks(data) {
    return post("/alignment/list", data);
  }

  /**
   * 创建对齐任务
   * @param {*} data
   * @returns
   */
  static createTask(data) {
    return post("/alignment/save", data);
  }

  /**
   * 编辑对齐任务
   * @param {*} data
   * @returns
   */
  static editTask(data) {
    return post("/alignment/save", data);
  }

  /**
   * 删除单个任务
   * @param {*} data
   */
  static deleteTask(data) {
    return get("/alignment/delete", data);
  }

  /**
   * 导出
   * @param {*} param0
   * @returns
   */
  static export(data) {
    return axios({
      method: "post",
      url: "/alignment/export",
      responseType: "blob",
      data,
    });
  }

  /**
   * 获得单个任务的详情
   * @param {*} data
   * @returns
   */
  static getTaskDetail(data) {
    return get("/alignment/detail", data);
  }

  /**
   * 重试解析或自动对齐
   * @param {*} data
   * @returns
   */
  static retry(data) {
    return get("/alignment/retry", data);
  }

  /**
   * 获得单个任务的状态
   * @param {*} params
   * @returns
   */
  static getTaskState(params) {
    return axios({
      method: "get",
      url: "/alignment/state",
      params,
    });
  }

  /**
   * 获得单个任务的对齐句子们
   * @param {*} params
   * @returns
   */
  static getSentences(params) {
    return axios({
      method: "get",
      url: "/alignment/list/sentences",
      params,
    });
  }

  /**
   * 保存单个任务的对齐段落/句子们
   * @param {*} data
   * @returns
   */
  static saveRows(data) {
    return axios({
      method: "post",
      url: "/alignment/rows/save",
      data,
    });
  }

  /**
   * 获取传入对齐任务的状态最新值
   * @param {Object} form
   * @returns
   */
  static getCurrentState(form) {
    var CancelToken = axios.CancelToken;
    var source = CancelToken.source();
    return [
      postWithCancelToken("/alignment/list/state", form, source.token),
      source,
    ];
  }

  /**
   * 获得单个任务的语言对
   * @param {*} params
   * @returns
   */
  static getLangs(params) {
    return axios({
      method: "get",
      url: "/alignment/langs",
      params,
    });
  }
}

/**
 * 对对齐完成的句段进行一次新的术语提取
 * @param {String} alignmentId
 * @param ateId
 * @param engine
 * @returns
 */
export function startATE(alignmentId, ateId, engine) {
  return post("/glossary/ate/extract", {
    ateId,
    /** 0:from alignment sentence */
    source: 0,
    parameter: JSON.stringify({ id: alignmentId, ...engine }),
  });
}

/**
 * 重新提取
 * @param {String} ateId
 * @returns
 */
export function retryATE(ateId) {
  return post("/glossary/ate/extract", {
    ateId,
  });
}
